export default "__VITE_ASSET__78b48d8d__"